import { Component, ElementRef, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { AccountSummaryService } from 'src/app/services/account-summary/account-summary.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { TimeService } from 'src/app/services/time-service/time.service';
import { MinutesToTimePipe } from '../../pipes/minutes-to-time.pipe';

@Component({
    selector: 'app-account-summary',
    templateUrl: './account-summary.component.html',
    styleUrls: ['./account-summary.component.scss'],
    imports: [
        MinutesToTimePipe
    ]
})
export class AccountSummaryComponent {
    @ViewChild('content') content: IonContent;
    @ViewChild('fixed') mapElement: ElementRef;

    tempSummary: any = {};

    public error = null;
    public summary: any[] = [];
    public fixedY: any = 50;
    public fixedHeight: any = 50;

    public selectedCurrency: string = 'USD';
    public totalRecords: number = 0;
    public emailDisabled = false;
    public submitDisabled = false;
    public searchDisabled = false;
    public showTable = false;
    public showNoResults = false;
    public showPagination = false;
    public environmentFlag: boolean = true;

    public toDate;
    public fromDate;
    public datePickerOptionsFromMin:string;
    public currentPage: number = 1;
    public maxPage: number = 1;
    public itemsPerPage = 20;

    public startDate: any;
    public searchInit: boolean = false;
    public isSportsApp: Boolean = false;
    public environmentName: string;
    dateRange: number;

    constructor(
        private accountSummaryService: AccountSummaryService,
        private config: ConfigService,
        private successMessageService:SuccessMessageService,
        private timeService: TimeService) {
        this.isSportsApp = this.config.isSportsApp();
    }

    calendarUpdate(event) {
        this.toDate = event.toDate;
        this.fromDate = event.fromDate;
        this.searchDisabled = event.search;
        this.successMessageService.clearMessage();
    }

    ionViewDidEnter() {
        this.successMessageService.clearMessage();
        // user can only get date within 6 months from now
        this.dateRange = 182;
        let today = new Date();
        let date = new Date();
        date = new Date(date.setDate(date.getDate()));

        this.startDate = new Date(date.setDate(date.getDate() - this.dateRange));
        this.toDate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(today));
        // fromDate: default is 2 days
        let fromDateDefault = new Date();
        fromDateDefault = new Date(fromDateDefault.setDate(fromDateDefault.getDate()-2));
        this.fromDate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(fromDateDefault));

        this.datePickerOptionsFromMin = this.startDate.toISOString().split('T')[0];

        this.selectedCurrency = this.accountSummaryService.getCustomer().preferredCurrency.currencyCode || 'USD';
    }

    sortLimits(limits) {
        limits = this.reorderLimits(limits);

        const depositLimits = limits.filter(limit => { return (limit.limitType.toUpperCase() === "DEPOSIT LIMIT" && (limit.limitSource === undefined || limit.limitSource === null)) });
        const wagerLimits = limits.filter(limit => { return (limit.limitType.toUpperCase() === "WAGER LIMIT" && limit.currentLimitTermType == "SINGLE") })
        const timeLimits = limits.filter(limit => { return limit.limitType.toUpperCase() === "TIME LIMIT" });
        const lossLimits = limits.filter(limit => { return limit.limitType.toUpperCase() === "LOSS LIMIT" });
        let spendLimits = limits.filter(limit => { return (limit.limitType.toUpperCase() === "WAGER LIMIT" && limit.currentLimitTermType != "SINGLE") });
        spendLimits.map((l) => {
            return l.limitType = "SPEND Limit";
        })
        limits = [...depositLimits, ...lossLimits, ...spendLimits, ...timeLimits, ...wagerLimits];

        return limits;
    }

    reorderLimits(limits) {
        return limits.sort((a, b) => {
            const aTermOrder = this.termToOrder[a.limitTerm];
            const bTermOrder = this.termToOrder[b.limitTerm];
            return (aTermOrder < bTermOrder) ? -1 : 1;
        });
    }
    termToOrder = {
        DAILY: 0,
        WEEKLY: 1,
        MONTHLY: 2,
        SINGLE: 3,
    }

    isSubmitDisabled() {
        return this.submitDisabled;
    }

    isEmailDisabled() {
        return this.emailDisabled;
    }

    onChangeCurrency(event) {
        this.searchInit = false;
        this.selectedCurrency = event.currentTarget.value;
        this.submitDisabled = false;
        this.searchDisabled = false;
    }

    onEmailMe(event) {
        this.emailDisabled = true;
    }

    onPageChange(event) {
        this.onSearch(Number(event));
    }

    onSearch(page?) {
        this.submitDisabled = true;
        this.searchDisabled = true;
        this.searchInit = true;
        this.summary = [];

        var requestObj: any = {};
        requestObj.dateFrom = this.fromDate;
        requestObj.dateTo = this.toDate;

        requestObj.currency_code = this.selectedCurrency;

        requestObj.pageno = (!!page) ? page : this.currentPage;

        this.accountSummaryService.callGetAccountSummary(requestObj).subscribe(
            (response: any) => {
                if (response && !!response.result) {
                    let pastAccountSummary = response.payload.past_account_summary;
                    // make an array for iterations.

                    this.summary = Object.keys(pastAccountSummary).map((k) => pastAccountSummary[k]);
                    this.summary.forEach(summaryItem => {
                        summaryItem.limits = this.sortLimits(summaryItem.limits);
                        summaryItem.limits = summaryItem.limits.filter(s => {
                            return (s.limitSource !== "GLOBAL");
                        })
                    });



                    const serverPageSize = response.payload.page_size;
                    const serverTotalPages = response.payload.total_pages;
                    const pageNumber = Number(response.payload.page_no);

                    this.totalRecords = response.payload.count;
                    this.currentPage = pageNumber;
                    this.maxPage = response.payload.total_pages;

                    if (serverTotalPages > 1) {
                        this.showPagination = true;
                    }

                    if (this.totalRecords > 0) {
                        this.showTable = true;
                        this.showNoResults = false;
                    }
                    else {
                        this.showNoResults = true;
                        this.showTable = false;
                    }
                }
            },
            (error) => {
                this.error = error;
            }
        );

        this.fixedY = this.mapElement.nativeElement.offsetHeight;
        // TODO find fix for content height
        // this.fixedHeight = this.content.contentHeight - this.fixedY;
    }

    numberFormat(number: any): string {
        if (!!number) {
            var num = number, rounded = number.rounded;
            return num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
        } else {
            return "";
        }
    }
}
